
import Vue from 'vue'
import AppMixin from '@/_mixins/app'
import lodash from 'lodash'
import { initOffboarding, searchProjectUsers } from '@/views/Authorization/utils/authorization'
import UserAvatar from '@/views/User/components/userAvatar.vue'
const ProjectUsers = Vue.extend({
    mixins: [AppMixin],
    components: { UserAvatar },
    props: {
        company: {
            type: Object,
            required: true,
        },
        searchTerm: {
            type: String,
            required: false,
            default: '',
        },
    },

    data() {
        return {
            loading: false,
            infiniteId: 0,
            offset: 0,
            limit: 50,
            projectUsers: [] as Array<any>,
        }
    },

    computed: {
        filteredUsers() {
            const groupedProjectUsers = this.lodash.groupBy(this.projectUsers, function (b) {
                return b.user.data ? b.user.data.id : b.email
            })

            const users = Object.values(groupedProjectUsers).map((item) => {
                const user = {
                    ...(item[0].user.data && { user: item[0].user.data }),
                    ...(!item[0].user.data && { email: item[0].email }),
                    projectUsers: item,
                    id: item[0].user.data ? item[0].user.data.id : item[0].email,
                }
                return user
            })
            return users
        },
    },

    methods: {
        initiateProjectUsers() {
            this.offset = 0
            this.infiniteId = Date.now()
            this.projectUsers = []
        },

        async loadProjectUsers($state: any) {
            let res = await searchProjectUsers({
                'filter[userKindIfConfirmed]': 'normal',
                'filter[project.owner]': this.company.id,
                'filter[hasRoles]': true,
                'page[offset]': this.offset,
                'page[limit]': this.limit,
                ...(this.searchTerm &&
                    this.searchTerm.length > 1 && { 'filter[searchTerm]': this.searchTerm }),
            })

            this.projectUsers = [...this.projectUsers, ...res]

            if (res.length == this.limit) {
                $state.loaded()
                this.offset += this.limit
            } else {
                $state.complete()
            }
        },
        async offboardUser(user: {
            user?: Record<string, any>
            email?: string
            projectUsers: Array<Record<string, any>>
        }) {
            const deletedProjectUsers = await initOffboarding(user)
            if (Array.isArray(deletedProjectUsers)) {
                this.offset -= deletedProjectUsers.length
                this.projectUsers = lodash.differenceBy(
                    this.projectUsers,
                    deletedProjectUsers,
                    'id'
                )
            }
        },
    },

    watch: {
        company: {
            immediate: true,
            deep: true,
            handler() {
                this.initiateProjectUsers()
            },
        },
        searchTerm: lodash.debounce(function (this) {
            this.initiateProjectUsers()
        }, 600),
    },
})

export default ProjectUsers
